import FormInput from '@c/forms/controls/FormInput';
import FormLabel from '@c/forms/controls/FormLabel';
import { zodResolver } from '@hookform/resolvers/zod';
import Button from '@ui/Button';
import { formatCurrency } from '@util/index';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import BaseModal from './BaseModal';
import { getDirtBikeShipping } from '@util/firestore/products';

interface EstimateDirtBikeShippingModalProps {
  product_id: string;
  isOpen: boolean;
  dismiss: () => void;
}
const estimateShippingSchema = z.object({
  country: z.string(),
  postal_code: z.string().min(4),
});
type EstimateShippingForm = z.infer<typeof estimateShippingSchema>;

export default function EstimateDirtBikeShippingModal({
  product_id,
  isOpen,
  dismiss,
}: EstimateDirtBikeShippingModalProps) {
  const [loading, setLoading] = useState(false);
  const [shippingCost, setShippingCost] = useState<number | null>(null);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<EstimateShippingForm>({
    defaultValues: {
      country: 'US',
    },
    resolver: zodResolver(estimateShippingSchema),
  });

  const onSubmit = async (form: EstimateShippingForm) => {
    setLoading(true);
    const cheapest = await getDirtBikeShipping({
      productId: product_id,
      zipCode: form.postal_code,
    });
    setShippingCost(cheapest.shipping_cost);
    setLoading(false);
  };

  return (
    <BaseModal isOpen={isOpen} dismiss={dismiss} title="Estimate Shipping">
      <form onSubmit={handleSubmit(onSubmit)} className="p-8">
        <div className="flex w-[30rem] flex-col gap-[2.4rem] p-5">
          {shippingCost === null ? (
            <div className="flex flex-col gap-6">
              <FormLabel value="Postal Code (US Only)" required>
                <FormInput
                  autoComplete="postal-code"
                  placeholder="90045"
                  error={!!errors.country}
                  {...register('postal_code')}
                />
              </FormLabel>
            </div>
          ) : (
            <div className="my-[5rem] text-center ">
              <h1 className="mb-5 text-7xl font-bold">
                {formatCurrency(shippingCost)}
              </h1>
              <h3>Estimated Cost</h3>
            </div>
          )}
          <div className="flex flex-col gap-[1.6rem]">
            {shippingCost === null && (
              <Button
                buttonType="submit"
                text="Get Estimate"
                type="secondary"
                loading={loading}
              />
            )}
            <div className="font-semibold text-brand-secondary">
              <Button
                text={shippingCost === null ? 'Cancel' : 'Close'}
                type="text"
                width="fluid"
                onClick={() => dismiss()}
              />
            </div>
          </div>
        </div>
      </form>
    </BaseModal>
  );
}
